import { render, staticRenderFns } from "./ShowroomLlSystemClassItemList.vue?vue&type=template&id=789e631c"
import script from "./ShowroomLlSystemClassItemList.vue?vue&type=script&lang=js"
export * from "./ShowroomLlSystemClassItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports